import {shouldCookieSuppressBanner} from '@github-ui/global-sso-banner-ui/cookie'
import type {SsoOrganization} from '@github-ui/global-sso-banner-ui/types'

/**
 * Determines whether the SSO banner should be visible based on:
 * 1. Whether there are SSO-protected orgs to show
 * 2. Whether the user has previously dismissed the banner (cookie check)
 * 3. On the needs_attention view, whether the server-reported count exceeds the
 *    visible task list — suggesting hidden tasks behind SSO auth
 */
export function shouldShowSsoBanner({
  ssoOrgs,
  isNeedsAttentionView,
  needsAttentionCount,
  totalTaskCount,
  hasActiveFilters,
}: {
  ssoOrgs: SsoOrganization[]
  isNeedsAttentionView: boolean
  needsAttentionCount: number | undefined
  totalTaskCount: number | undefined
  hasActiveFilters: boolean
}): boolean {
  if (ssoOrgs.length === 0) return false

  const dismissedByCookie = shouldCookieSuppressBanner(ssoOrgs)

  if (!dismissedByCookie) return true

  // On the needs_attention view with no filters active, override the dismissal
  // if the badge count exceeds the list total — suggesting tasks are hidden
  // behind SSO authentication. Skip when filters are active since the badge is
  // always unfiltered and a mismatch is expected.
  if (isNeedsAttentionView && !hasActiveFilters && needsAttentionCount != null && totalTaskCount != null) {
    return needsAttentionCount > totalTaskCount
  }

  return false
}
